import { Alergia } from '../models/alergias.model';
import { ENV, URL_CIDADAO } from './../util/constants';
import { AuthenticateService } from './authenticate.service';
import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Usuario } from 'src/models/usuario.model';

@Injectable({
  providedIn: 'root'
})
export class AlergiasService {
  categoria = {
    alimentar: [
      {
        nome: 'Leite e derivados', categoria: 'alimentar', icone: 'leite', select: false, show: true, adicionado: false
      },
      {
        nome: 'Ovos', categoria: 'alimentar', icone: 'ovos', select: false, show: true, adicionado: false
      },
      {
        nome: 'Carne bovina', categoria: 'alimentar', icone: 'carne-bovina', select: false, show: true, adicionado: false
      },
      {
        nome: 'Peixe', categoria: 'alimentar', icone: 'peixe', select: false, show: true, adicionado: false
      },
      {
        nome: 'Crustáceos (Camarão e outros crustáceos)', categoria: 'alimentar', icone: 'camarao', select: false, show: true, adicionado: false
      },
      {
        nome: 'Lula', categoria: 'alimentar', icone: 'lula', select: false, show: true, adicionado: false
      },
    ],
    animais: [
      {
        nome: 'Gato', categoria: 'animais', icone: 'gato', select: false, show: true, adicionado: false
      },
      {
        nome: 'Cachorro', categoria: 'animais', icone: 'cachorro', select: false, show: true, adicionado: false
      },
      {
        nome: 'Abelha', categoria: 'animais', icone: 'abelha', select: false, show: true, adicionado: false
      },
      {
        nome: 'Formiga', categoria: 'animais', icone: 'formiga', select: false, show: true, adicionado: false
      },
      {
        nome: 'Animais peçonhentos', categoria: 'animais', icone: 'peconhetos', select: false, show: true, adicionado: false
      },
      {
        nome: 'Insetos', categoria: 'animais', icone: 'insetos', select: false, show: true, adicionado: false
      },
    ],
    medicamentos: [
      {
        nome: 'Dipirona', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'AAS', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Diclofenaco', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Paracetamol', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Penicilina', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Magnésio Bisurado', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Rivaroxabana', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Losartana potássica', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'Metformina', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
      {
        nome: 'butilbrometo de escopolamina', categoria: 'medicamentos', icone: 'remedio', select: false, show: true, adicionado: false
      },
    ],
    outros: [],
  };

  constructor(private http: RequestService, private platfom: Platform, private auth: AuthenticateService) {

  }

  async recuperarAlergias() {
    return await this.http.get(`${URL_CIDADAO}cartaosus/rest/alergia`,
      null, this.getHeadersToken()).then(result => {
        return result.map(data => new Alergia(data));
      }).catch((error) => {
        return [];
      });
  }

  async recuperarMinhasAlergias() {
    return this.http.get(`${URL_CIDADAO}cartaosus/rest/minhaalergia`,
      null, this.getHeadersToken()).then(result => {
        return result.map(data => new Alergia(data));
      }).catch((error) => {
        console.error('error', error);

        if (ENV === 'DEV') {
          return [
            {
              numeroCartao: null,
              id: 2294411,
              idAlergia: 11,
              nome: "Outra Alergia Medicamentosa",
              tipo: 1,
              outra: "AAS",
            },
            {
              numeroCartao: null,
              id: 2294366,
              idAlergia: 12,
              nome: "Outra Alergia Alimentar",
              tipo: 2,
              outra: "Peixe",
            },
            {
              numeroCartao: null,
              id: 2294449,
              idAlergia: 13,
              nome: "Outra Alergia",
              tipo: 3,
              outra: "Formiga",
            },
            {
              numeroCartao: null,
              id: 2294393,
              idAlergia: 13,
              nome: "Outra Alergia",
              tipo: 3,
              outra: "Abelha",
            },
            {
              numeroCartao: null,
              id: 2294383,
              idAlergia: 12,
              nome: "Outra Alergia Alimentar",
              tipo: 2,
              outra: "Carne bovina",
            },
          ];
        }
      });
  }

  getHeaders() {
    const httpOptions = {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: this.auth.getAuthorizationToken()
    };

    return httpOptions;
  }

  getHeadersToken() {
    const server = JSON.parse(localStorage.getItem('app_icp_token'));
    const token = this.auth.getAuthorizationToken();
    const httpOptions = {
      'Content-Type': 'application/json',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + token,
    };

    return httpOptions;
  }


  getHeadersJson() {
    const httpOptions = {
      'Content-Type': 'application/json'
    };

    return httpOptions;
  }

  async getCategory(list) {
    var categorias = this.categoria;
    this.categoria.alimentar.forEach((value, index) => {
      this.categoria.alimentar[index].select = false;
      this.categoria.alimentar[index].adicionado = false;
    });
    this.categoria.animais.forEach((value, index) => {
      this.categoria.animais[index].select = false;
      this.categoria.animais[index].adicionado = false;
    });
    this.categoria.medicamentos.forEach((value, index) => {
      this.categoria.medicamentos[index].select = false;
      this.categoria.medicamentos[index].adicionado = false;
    });
    list.forEach(item => {
      categorias.outros = [];
      categorias[item.categoria].forEach((value, index) => {
        if (item.nome.toLowerCase() === value.nome.toLowerCase() ||
          (item.outra && item.outra.toLowerCase() === value.nome.toLowerCase())) {
          categorias[item.categoria][index].select = true;
          categorias[item.categoria][index].adicionado = true;
        }
      });
    });
    return categorias;
  }

  async verifyCategory(item) {
    let category = {
      categoria: 'outros',
      icone: 'outros'
    };
    this.categoria.alimentar.forEach((value, index) => {
      if (item.nome.toLowerCase() === value.nome.toLowerCase() || (
        item.outra && item.outra.toLowerCase() === value.nome.toLowerCase() &&
        item.nome.toLowerCase() === 'outra alergia') || item.nome.toLowerCase() === 'outra alergia alimentar') {
        category = value;
      }
    });
    this.categoria.animais.forEach((value, index) => {
      if (item.nome.toLowerCase() === value.nome.toLowerCase() ||
        (item.outra && item.outra.toLowerCase() === value.nome.toLowerCase() &&
          item.nome.toLowerCase() === 'outra alergia') || item.nome.toLowerCase() === 'outra alergia animais') {
        category = value;
      }
    });
    this.categoria.medicamentos.forEach((value, index) => {
      if (item.nome.toLowerCase() === value.nome.toLowerCase() ||
        (item.outra && item.outra.toLowerCase() === value.nome.toLowerCase() &&
          item.nome.toLowerCase() === 'outra alergia') || item.nome.toLowerCase() === 'outra alergia medicamentosa') {
        category = value;
      }
    });

    return category;
  }
}
